export function formatPrice(cents: number): string {
  return (cents / 100).toFixed(2);
}

export function maskPhone(countryCode: string, localNumber: string): string {
  const digits = localNumber.replace(/\D/g, '');
  if (digits.length < 4) return `${countryCode} ${localNumber}`;
  const visible = digits.slice(-4);
  const masked = '•'.repeat(Math.max(0, digits.length - 4));
  return `${countryCode} ${masked}${visible}`;
}
